import * as DND from "react-dnd";
import { Link } from "react-router";
let TouchBackend = require('react-dnd-touch-backend').default;
import { AdjacencyMatrixGraph, Edge } from "Math/Graph";
import * as _ from "lodash";
import * as React from "react";
import * as Sauce from "Sauce";
import * as ReactDOM from "react-dom";
import * as $ from "jquery";
import { Position2 } from "Math/Geometry";
import * as Rx from "rxjs";
import * as Util from "Util";
import { NumberInput, StringTextInput } from "Sauce/Form";
import { ParseResult } from "Sauce/Validation";
import { Real as RealNumber, Label } from "Sauce/Validation/Basic";
import { Latex } from "UI/Math/Latex";
import * as d3 from "d3";
import { Popover, PopoverTitle, PopoverContent, Button, Tooltip } from "reactstrap";
import { Vec2, AxisAlignedBox2 } from "Math/Algebra";
import * as Validation from "Sauce/Validation";
import * as Validators from "Sauce/Validation/Basic";

require("./GraphBuilder.scss");
import Clipboard = require("clipboard");


export interface NodeProps {
    label?: string;
    position: DND.ClientOffset;
}
export interface EdgeProps {
    weight: number;
    weightParseResult: ParseResult<number>;
}

export interface NodeSelections {
    primarySelectionId: string | null;
    secondarySelectionIds: string[];
}

export interface GraphProps<NodeProps> {
    graph: AdjacencyMatrixGraph<NodeProps, EdgeProps>;
}

export interface GraphBuilderState {
    nodeSelections: NodeSelections;
    nodeRect: { width: number; height: number; };
}

@(DND.DragDropContext as any)(TouchBackend({ enableMouseEvents: true }))
export class GraphBuilder extends React.Component<GraphProps<NodeProps>, GraphBuilderState>  {
    propTypes?: React.ValidationMap<GraphProps<NodeProps>>;
    contextTypes?: React.ValidationMap<any>;
    childContextTypes?: React.ValidationMap<any>;
    defaultProps?: GraphProps<NodeProps>;
    displayName?: string;

    constructor(props?: GraphProps<NodeProps>, context?: any) {
        super(props);
        this.state = { 
            nodeSelections: { primarySelectionId: null, secondarySelectionIds: [] }, 
            nodeRect: { width: 50, height: 50 },
        };
    }
    private setSelection = (selections: NodeSelections) => {
        this.setState({ nodeSelections: selections });
    }
    private clearSelection = () => {
        this.setState({ nodeSelections: { primarySelectionId: null, secondarySelectionIds: [] } });
    }
    private signalNodeRect = (rect: { width: number, height: number }) => {
        if (this.state.nodeRect.width != rect.width || this.state.nodeRect.height != rect.height) {
            this.setState({ nodeRect: rect });
        }
    };
    private removeNode = (id: string) => {
        let nodeSelections = {
            primarySelectionId: this.state.nodeSelections.primarySelectionId !== id ? this.state.nodeSelections.primarySelectionId : null,
            secondarySelectionIds: this.state.nodeSelections.secondarySelectionIds.filter(i => i !== id)
        }
        this.setState({ nodeSelections: nodeSelections });
        this.props.graph.removeNode(id);
    }

    render() {
        const { graph } = this.props;

        return <div className="graph-builder">
            <div className="graph-container">
                <NodeWell graph={graph} />
                <DragPreviewLayer />
                <GraphCanvas
                    graph={graph}
                    nodeRect={this.state.nodeRect}
                    signalNodeRect={this.signalNodeRect}
                    nodeSelections={this.state.nodeSelections}
                    clearSelection={this.clearSelection}
                    setSelection={this.setSelection}
                    removeNode={this.removeNode}
                    connectDropTarget={() => ({} as any)}
                    isOver={true} />
                <SvgGraphCanvas
                    graph={graph}
                    nodeRect={this.state.nodeRect}
                    signalNodeRect={this.signalNodeRect}
                    nodeSelections={this.state.nodeSelections}
                    clearSelection={this.clearSelection}
                    setSelection={this.setSelection}
                    removeNode={this.removeNode}
                    connectDropTarget={() => ({} as any)}
                    isOver={true} />
            </div>
        </div>
    }
}
const DragItemTypes = {
    NEWNODE: "new-node",
    MAINNODE: "main-node"
}

interface NodeDragObject {
    id: string;
}

interface NodeSourceProps {
    isDragging: boolean;
    connectDragSource: DND.ConnectDragSource;
    graph: AdjacencyMatrixGraph<NodeProps, EdgeProps>
}
function nextNodeId(graph: AdjacencyMatrixGraph<NodeProps, EdgeProps>) {
    return "node-" + graph.nextIdNumber();
}
// Spec: drag events to handle.
let nodeSourceSpec: DND.DragSourceSpec<NodeSourceProps> = {
    beginDrag: (props: NodeSourceProps) => ({ label: nextNodeId(props.graph) }),
};

// Collect: Put drag state into props
let nodeSourceCollector = (connect: DND.DragSourceConnector, monitor: DND.DragSourceMonitor) => {
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging()
    }
};

@DND.DragSource(DragItemTypes.NEWNODE, nodeSourceSpec, nodeSourceCollector)
class NodeSource extends React.Component<NodeSourceProps, {}> {
    constructor(props: NodeSourceProps) {
        super(props);
    }
    render() {
        const { connectDragSource, isDragging, graph } = this.props;
        return connectDragSource(<div><Button>{nextNodeId(graph)}</Button></div>);
    }
}

interface NodeWellProps {
    graph: AdjacencyMatrixGraph<NodeProps, EdgeProps>;
}
interface NodeWellState { tooltipOpen: boolean, deepLinkTooltipOpen: boolean }
class NodeWell extends Sauce.Component<NodeWellProps, NodeWellState> {
    private helpid = "help-tooltip";
    static contextTypes = { /* this is required to get react router context injected */
        router: React.PropTypes.object
    }
    constructor(props: NodeWellProps) {
        super(props);
        this.state = { tooltipOpen: false, deepLinkTooltipOpen: false };
    }
    toggle = () => {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }
    toggleDeepLink = () => {
        this.setState({
            deepLinkTooltipOpen: !this.state.deepLinkTooltipOpen
        })
    }
    copyDeepLink = () => {

    }
    makeDeepLink = () => `${window.location.origin}/markov/${this.props.graph.serialize()}`;

    render() {
        new Clipboard("#showdeeplink");

        return <div className="node-well">
            <NodeSource isDragging={false}
                connectDragSource={null as any}
                graph={this.props.graph} />

            <Link to={this.makeDeepLink()}>
                <Button data-clipboard-text={this.makeDeepLink()} id="showdeeplink" className="ml-1" color="secondary" onClick={this.copyDeepLink}>Link</Button>
            </Link>
            <Tooltip
                placement="bottom"
                tether={{ constraints: [{ to: 'scrollParent', pin: true }] }}
                isOpen={this.state.deepLinkTooltipOpen}
                target="showdeeplink"
                toggle={this.toggleDeepLink}>

                Click to copy a permanent link to the current graph to your clipboard.
            </Tooltip>

            <Button className="mr-1" color="secondary" id={this.helpid}>?</Button>
            <Tooltip
                placement="bottom"
                tether={{ constraints: [{ to: 'scrollParent', pin: true }] }}
                isOpen={this.state.tooltipOpen}
                target={this.helpid}
                toggle={this.toggle}>
                <h4>Create New Nodes</h4>
                <ul>
                    <li>Drag the node in the blue area onto the graph.</li>
                    <li>Or, cmd-click on the graph.</li>
                </ul>
                <h4>Create New Edges</h4>
                <ul>
                    <li>Click one node to select the start node.</li>
                    <li>Select any number of additional nodes, including the start node itself.</li>
                    <li>Press enter.</li>
                    <li>Enter the weight for the edges to or from the start node to the other nodes you selected.</li>
                    <li>As with all number inputs on this website, the weight field accepts arbitrary mathjs expressions, such as "sin(pi/2)" or "1/6".</li>
                    <li>Press enter again to set edges to or from the start node to all selected nodes.</li>
                </ul>
                <h4>Remove Nodes</h4>
                <ul>
                    <li>Drag them off the canvas.</li>
                </ul>

            </Tooltip>
        </div>
    }
}


const layerStyles = {
    position: 'fixed',
    pointerEvents: 'none',
    zIndex: 100,
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    fontSize: '4em'
};

interface PDragLayer {
    item: any;
    itemType: string;
    initialOffset: Position2;
    currentOffset: Position2;
    isDragging: boolean;
}

function getItemStyles(props: PDragLayer) {
    const { initialOffset, currentOffset } = props;
    if (!initialOffset || !currentOffset) {
        return {
            display: 'none'
        };
    }

    let { x, y } = currentOffset;

    const transform = `translate(${x}px, ${y}px)`;
    return {
        transform: transform,
        WebkitTransform: transform
    };
}

function renderItem(type: string, item: any) {
    // Right now all of our drags previews look the same;
    return <Button>{item.label}</Button>
}

@DND.DragLayer(monitor => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging()
}))
class DragPreviewLayer extends React.Component<any, {}> {
    constructor(props: any) {
        super(props);
    }
    render() {
        const { item, itemType, isDragging } = this.props;

        if (!isDragging) {
            return null;
        }
        let rendered = renderItem(itemType, item);

        return (
            <div style={layerStyles}>
                <div style={getItemStyles(this.props)}>
                    {rendered}
                </div>
            </div>
        );
    }
}

enum SelectionMode {
    PRIMARY,
    SECONDARY
}
/* The main part of a graph node. Dragging this moves the node within the canvas or removes the node if dragged off canvas */
interface CanvasNodeMainProps {
    id: string;
    node: NodeProps;
    connectNodeDrag: DND.ConnectDragSource;
    selectionMode: SelectionMode[];
    nodeRect: { width: number; height: number };
    signalNodeRect: (rect: { width: number; height: number; }) => void;
    clickNode: (id: string) => void; // signal that this node has been clicked
    removeNode: () => void;
}
let graphNodeSpec: DND.DragSourceSpec<CanvasNodeMainProps> = {
    beginDrag: (props: CanvasNodeMainProps) => ({ id: props.id, label: props.node.label, nodeRect: props.nodeRect }),
    endDrag: (props: CanvasNodeMainProps, monitor: DND.DragSourceMonitor) => {
        if (!monitor.didDrop()) {
            props.removeNode();
        }
    }
}
let graphNodeCollector = (connect: DND.DragSourceConnector, monitor: DND.DragSourceMonitor) => {
    return {
        connectNodeDrag: connect.dragSource(),
        isDragging: monitor.isDragging()
    }
};

class CanvasNodeMain extends React.Component<CanvasNodeMainProps, {}> {
    dom: HTMLDivElement;
    constructor(props: CanvasNodeMainProps) {
        super(props);
        this.state = { nodeRect: null };
    }
    private signal = (dom: HTMLDivElement) => {
        return dom && this.props.signalNodeRect(dom.getBoundingClientRect())
    };
    render() {
        const { id, node, connectNodeDrag, selectionMode } = this.props;
        let innerBorder = selectionMode.includes(SelectionMode.PRIMARY) ? <div className="node-selection-primary" /> : null;
        let outerBorder = selectionMode.includes(SelectionMode.SECONDARY) ? <div className="node-selection-secondary" /> : null;

        return <div id={id} ref={this.signal}>
            {innerBorder}
            {outerBorder}
            <Button>{node.label}</Button>
        </div>
    }
}

class _CanvasNode extends React.Component<CanvasNodeMainProps, { promptWeight: boolean }> {
    constructor(props: CanvasNodeMainProps) {
        super(props);
        this.state = { promptWeight: false };
    }
    toggle = () => this.setState(prevState => ({ promptWeight: !prevState.promptWeight }));

    render() {
        const { id, connectNodeDrag, node, selectionMode, clickNode, nodeRect, removeNode} = this.props;
        let classes = "canvas-node";

        let g = connectNodeDrag(<div className={classes}
            onClick={(ev: React.MouseEvent<HTMLElement>) => {
                clickNode(id);
            } }
            style={{ top: node.position.y, left: node.position.x }}>

            <CanvasNodeMain
                id={id}
                nodeRect={nodeRect}
                signalNodeRect={this.props.signalNodeRect}
                node={node}
                clickNode={clickNode}
                selectionMode={selectionMode}
                connectNodeDrag={connectNodeDrag}
                removeNode={removeNode} />

        </div>);

        return g;

    }
}
let CanvasNode = DND.DragSource(DragItemTypes.MAINNODE, graphNodeSpec, graphNodeCollector)(_CanvasNode) as any;

interface PEdgeWeightForm {
    primaryId: string;
    secondaryIds: string[];
    graph: AdjacencyMatrixGraph<NodeProps, EdgeProps>;
    clearSelection: () => void;
    setWeight: (a: string, b: string[], weight: ParseResult<number>, tofrom: "to" | "from") => void;
}

interface EdgeWeightFormState {
    tofrom: "to" | "from";
}

class EdgeWeightForm extends Sauce.Component<PEdgeWeightForm, EdgeWeightFormState> {
    private validateWeight = new RealNumber().make();
    private validateLabel = new Label().make();
    constructor(props: PEdgeWeightForm) {
        super(props);
        this.state = {
            tofrom: "to",
        }
    }
    componentDidMount() {
        let el = ReactDOM.findDOMNode(this);
        $(el).children(".edge-weight-value").select();
    }

    render() {
        let { graph, primaryId, secondaryIds  } = this.props;
        const { tofrom } = this.state;
        let nodeId = this.props.primaryId;
        let displayWeight: string;

        let weights = secondaryIds
            .map(s => tofrom === "to" ? graph.getEdge(primaryId, s) : graph.getEdge(s, primaryId))

        if (weights.length > 0) {
            if (weights.every(w => w.weight === weights[0].weight)) {
                displayWeight = weights[0].weightParseResult.raw;
            }
            else {
                displayWeight = "multiple values";
            }
        }

        return <div className="edge-weight">
            <div onChange={ev => this.setState({ tofrom: (ev.target as any).value })}>
                <input type="radio" value="to" name="tofrom" defaultChecked={this.state.tofrom === "to"} />To
          <input type="radio" value="from" name="tofrom" defaultChecked={this.state.tofrom === "from"} />From
        </div>
            <label className="edge-weight-value-label">Weight</label>
            <NumberInput className="edge-weight-value"
                autoFocus={true}
                value={displayWeight}
                processor={this.validateWeight}
                flush={val => {
                    if (val.valid) {
                        this.props.setWeight(this.props.primaryId, this.props.secondaryIds, val, this.state.tofrom);
                    }
                } } />
            <StringTextInput className="node-label"
                value={graph.getNodeById(primaryId).label}
                processor={this.validateLabel}
                flush={val => {
                    if (val.valid) {
                        graph.setNode(nodeId, { label: val.value })
                    }
                } } />
        </div>
    }
}

/* main graph area */
interface GraphCanvasProps {
    connectDropTarget: DND.ConnectDropTarget,
    isOver: boolean,
    graph: AdjacencyMatrixGraph<NodeProps, EdgeProps>;
    clearSelection: () => void;
    setSelection: (selections: NodeSelections) => void;
    signalNodeRect: (rect: { width: number; height: number; }) => void;
    nodeRect: { width: number, height: number };
    nodeSelections: NodeSelections;
    removeNode: (id: string) => void;
}

const canvasDropTargetSpecification: DND.DropTargetSpec<GraphCanvasProps> = {
    drop(props: GraphCanvasProps, monitor: DND.DropTargetMonitor, component: React.Component<GraphCanvasProps, {}>) {
        let pos = monitor.getSourceClientOffset();
        let offset = ReactDOM.findDOMNode(component).getBoundingClientRect();

        let relpos = {
            x: pos.x - offset.left,
            y: pos.y - offset.top
        }

        let { graph } = props;
        if (monitor.getItemType() === DragItemTypes.MAINNODE) {
            let node = (monitor.getItem() as NodeDragObject);
            graph.setNode(node.id, { position: relpos });
        }
        else if (monitor.getItemType() === DragItemTypes.NEWNODE) {
            const nodeid = nextNodeId(graph);
            graph.addNode(nodeid, { position: relpos, label: nodeid });
        }
    },
};

function canvasDropTargetCollectingFunction(connect: DND.DropTargetConnector, monitor: DND.DropTargetMonitor) {
    return {
        connectDropTarget: connect.dropTarget(),
        isOver: monitor.isOver(),
    };
}

@(DND.DropTarget as any)([DragItemTypes.NEWNODE, DragItemTypes.MAINNODE], canvasDropTargetSpecification, canvasDropTargetCollectingFunction)
class GraphCanvas extends React.Component<GraphCanvasProps, { promptingWeight: boolean }> {
    constructor(props: GraphCanvasProps) {
        super(props);
        this.state = { promptingWeight: false };
    }
    private setWeight = (a: string, b: string[], weight: ParseResult<number>, tofrom: "to" | "from") => {
        let { graph } = this.props;
        if (weight.valid) {
            if (tofrom === "to") {
                graph.setEdge(a, b, { weight: weight.value, weightParseResult: weight });
            }
            else {
                graph.setEdge(b, a, { weight: weight.value, weightParseResult: weight });
            }
        }
    }
    private clickNode = (id: string) => {
        let { nodeSelections } = this.props;
        if (!nodeSelections.primarySelectionId) {
            nodeSelections.primarySelectionId = id;
        }
        else {
            if (nodeSelections.primarySelectionId === id) {
                nodeSelections.secondarySelectionIds.push(id);
            }
            else {
                if (nodeSelections.secondarySelectionIds.includes(id)) {
                    nodeSelections.secondarySelectionIds = nodeSelections.secondarySelectionIds.filter(i => i !== id);
                }
                else {
                    nodeSelections.secondarySelectionIds.push(id);
                }
            }
        }
        this.props.setSelection(nodeSelections);
    }
    private clickGraph = (ev: React.MouseEvent<HTMLDivElement>) => {
        let { graph } = this.props;
        if (ev.target == ev.currentTarget && ev.metaKey) {
            let pos = { x: ev.pageX, y: ev.pageY };
            let centerNodeOffset = this.props.nodeRect;
            let offset = ReactDOM.findDOMNode(this).getBoundingClientRect();

            let relpos = {
                x: pos.x - Math.floor(centerNodeOffset.width / 2) - offset.left,
                y: pos.y - Math.floor(centerNodeOffset.height / 2) - offset.top
            }

            const id = nextNodeId(graph);
            graph.addNode(id, { position: relpos, label: id });
        }
    }

    private onEnter() {
        const { primarySelectionId, secondarySelectionIds } = this.props.nodeSelections;
        if (this.state.promptingWeight) {
            this.clearSelection();
        }
        else if (primarySelectionId && secondarySelectionIds && secondarySelectionIds.length > 0) {
            this.setState({ promptingWeight: true });
        }
    }
    componentDidMount() {
        const { primarySelectionId, secondarySelectionIds } = this.props.nodeSelections;
        window.addEventListener("keydown", ev => {
            if (ev.keyCode === 27 /*esc*/) {
                this.clearSelection();
            }
            else if (ev.keyCode === 13 /*enter*/) {
                this.onEnter();
            }
        });
    }

    getSelectionMode(id: string, { primarySelectionId, secondarySelectionIds}: NodeSelections) {
        let selectionMode: SelectionMode[] = [];
        if (primarySelectionId === id) {
            selectionMode.push(SelectionMode.PRIMARY);
        }
        if (secondarySelectionIds.includes(id)) {
            selectionMode.push(SelectionMode.SECONDARY);
        }
        return selectionMode;
    }
    clearSelection = () => {
        this.setState({ promptingWeight: false });
        this.props.clearSelection();
    }
    render() {
        const { connectDropTarget, graph, removeNode } = this.props;
        const { primarySelectionId, secondarySelectionIds } = this.props.nodeSelections;
        const { promptingWeight } = this.state;
        let nodeEls = graph.getNodeIds().map(k => {
            let node = graph.getNodeById(k);

            return <CanvasNode
                key={k}
                id={k}
                graph={graph}
                clickNode={this.clickNode}
                signalNodeRect={this.props.signalNodeRect}
                selectionMode={this.getSelectionMode(k, this.props.nodeSelections)}
                removeNode={() => removeNode(k)}
                node={graph.getNodeById(k)}
                connectNodeDrag={null as any} />
        });

        let edgeWeight = promptingWeight && primarySelectionId && <Popover
            placement="top"
            target={primarySelectionId}
            isOpen={true}>

            <PopoverContent><EdgeWeightForm
                key={1}
                graph={graph}
                setWeight={this.setWeight}
                primaryId={primarySelectionId}
                secondaryIds={secondarySelectionIds}
                clearSelection={this.clearSelection} /></PopoverContent>
        </Popover>;

        let hiddenNodeProps: NodeProps = {
            position: { x: 0, y: 0 },
            label: "node-0"
        }

        let hiddenMeasuringNode = <div style={{ visibility: "hidden" }}><CanvasNode graph={graph} clickNode={() => ({})} signalNodeRect={this.props.signalNodeRect}
            selectionMode={[]} connectNodeDrag={null as any} node={hiddenNodeProps} /></div>
        return connectDropTarget(<div className="graph-canvas" onClick={this.clickGraph}>
            {hiddenMeasuringNode}
            {edgeWeight}
            {nodeEls}
        </div>);
    }
}

enum Orientation { top, right, bottom, left };
class SvgGraphCanvas extends React.Component<GraphCanvasProps, {}> {
    constructor(props: GraphCanvasProps) {
        super(props);
    }

    render() {
        let boxBottomRight = new Vec2(this.props.nodeRect.width, this.props.nodeRect.height);
        let midpoint = boxBottomRight.scalar(1 / 2);
        let markerWidth = 6;
        let makeD = d3.line<{ x: number; y: number }>()
            .x(({x}) => x)
            .y(({y}) => y);

        const { graph } = this.props;
        const { primarySelectionId, secondarySelectionIds } = this.props.nodeSelections;

        let linkEls = graph.getNonNullEdges().map(e => {
            if (e.val.weight === 0) return;
            const fromNode = graph.getNodeById(e.from);
            const toNode = graph.getNodeById(e.to);
            let from = new Vec2(fromNode.position);
            let to = new Vec2(toNode.position);
            let p: JSX.Element;
            let t = to.plus(midpoint);
            if (to.equal(from)) {
                let c1 = t.plus(new Vec2(-75, -100));
                let c2 = t.plus(new Vec2(-75, 100));
                return <path d={"M" + t.minus(new Vec2(0.25 * midpoint.x, midpoint.y)).d() +
                    "C" + c1.d() + c2.d() + t.plus(new Vec2(-0.25 * midpoint.x, midpoint.y + 8)).d()}
                    key={e.from + "_" + e.to} markerEnd="url(#Arrowhead)" fill="none" stroke="steelblue" strokeWidth="2" />;
            }


            /*  135          45
                  \  top   /
                    \      /
              left   from   right
                    /     \
                    /  bot   \   
                -135         -45  */

            // let or: Orientation;
            // let angle = a.angleXAxisDeg();
            // if (angle < 0) {
            //   angle = 360 + angle;
            // }
            // if (angle > 360-45 || angle <= 45) {
            //   or = Orientation.right;
            // }
            // else if (angle > 45 && angle <= 135) {
            //   or = Orientation.top;
            // }
            // else if ( angle > 135 && angle <= 225) {
            //   or = Orientation.left;
            // }
            // else if (angle > 225 && angle <= 360-45) {
            //   or = Orientation.bottom;
            // }

            let toBox = new AxisAlignedBox2(to, to.plus(boxBottomRight));
            let f = from.plus(midpoint);

            let intersect = t.boxIntersectionPoint(toBox, f);
            // Shorten the vector by 10 in the direction from f to t, 
            // then translate it back to our origin coord system
            let translatedIntersect = intersect.minus(f);
            let edgeTerminator = translatedIntersect.scaleTo(translatedIntersect.norm() - 10).plus(f);

            try {
                p = <path d={makeD([f, edgeTerminator])} key={e.from + "_" + e.to} markerEnd="url(#Arrowhead)" fill="none" stroke="steelblue" strokeWidth="2" />;
            }
            finally {
                return p;
            }
        });
        let arrow = React.createElement(
            "marker",
            { id: "Arrowhead", markerWidth: markerWidth, markerHeight: "6", orient: "auto", refX: "1", refY: "5", viewBox: "0 0 10 10" },
            <path d="M 0 0 L 10 5 L 0 10 z" />);

        let canvas = <svg key={0} className="graph-canvas">
            <defs>{arrow}  </defs>
            {linkEls}
        </svg>;

        return canvas;
    }
}



// WEBPACK FOOTER //
// ./src/code/UI/Math/GraphBuilder.tsx